import { useEffect, useRef, useState } from 'react'
import styles from './ExpandableText.module.scss'
import cl from 'classnames'
import { useTranslation } from 'react-i18next'

let HEIGHT = 46

export const ExpandableText = ({ height = HEIGHT, children }) => {
	const { t } = useTranslation()

	const contentRef = useRef(null)
	const [expanded, setExpanded] = useState(false)
	const [clamped, setClamped] = useState(false)

	useEffect(() => {
		if (contentRef.current) {
			setClamped(contentRef.current.scrollHeight > height)
		}
	}, [children])

	return (
		<div className={cl(styles.wrapper)}>
			<div
				ref={contentRef}
				className={cl(styles.content,{ [styles.more]: !expanded && clamped })}
				style={{
					maxHeight: !expanded && clamped ? height : 'none',
				}}
			>
				{children}
			</div>
			{!expanded && clamped && (
				<div>
					<button className={styles.button} onClick={() => setExpanded(true)}>{t('more')}</button>
				</div>
			)}
			{expanded && clamped && (
				<div>
					<button className={styles.button} onClick={() => setExpanded(false)}>{t('hide')}</button>
				</div>
			)}
		</div>
	)
}